import { Component, Input, OnInit } from '@angular/core';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { FilterService } from 'app/shared/filter/filter.service';
import { WorkflowService } from 'app/services/workflow.service';
import { environment } from 'environments/environment';
import { CarrierService } from 'app/services/carrier.service';
import { Observable  } from 'rxjs';
import { ApplicationService } from 'app/services/application.service';
import { Router } from '@angular/router';
import { WFInboxFilterConfig } from 'app/shared/filter/filter.constant';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-unassigned',
  templateUrl: './unassigned.component.html',
  styleUrls: ['./unassigned.component.scss']
})
export class UnassignedComponent implements OnInit {
  @Input("ctrlData") ctrlData: any;
  flags = { flagAN: 1, flagAT: 1, flagS: 1, flagDA: 1 };
  ranks = { flagAN: 1, flagAT: 2, flagS: 3, flagDA: 4 };
  sortLabels = {
    flagAN: "ApplicationNumber",
    flagAT: "ApplicationType",
    flagS: "Status",
    flagDA: "DateAssigned",
  };
  direction: boolean = false;
  criteria = "DateAssigned";
  rankCtrl: number = 2;
  activities: any = [];
  isLoading: Boolean = false;
  message: string = "Loading activities, please wait...";
  statuses: any = [];
  keyword: any = {};
  currentPage = 1;
  isEmpty: boolean = false;
  pageSize: number = 10;
  count: number = 0;
  disabled = false;
  ShowFilter = true;
  limitSelection = false;
  selectedItems: any = [];
  dropdownSettings: any = {};
  carrierNumber: string;
  carrierName: string;
  processFlag: boolean = false;
  currentUserName: string = "";
  userData: any = environment.authWebApi.userData;
  workflow_role: number;
  workflow_user: string;
  workflow_rolename: string;
  selectedcarrier: any = null;
  selectedIndex: number;

  roleUsers: any = [];
  activity_id: number;
  assigneduser: string;
  assignedusername: string;

  companyRegNumber: string;
  first_Name: string;
  surname: string;
  id_number: string;

  CarrierName: string;
  WFAppType: string;
  Status: string;

  filterConfig = WFInboxFilterConfig;

  constructor(
    private service: WorkflowService,
    private carrierService: CarrierService,
    private applicationService: ApplicationService,
    private router: Router,
    private toater: ToastNotificationService,
    private filter: FilterService,
    public utility: UtilityServiceService,
    private dialog: ConfirmDialogService
  ) {}

  ngOnInit(): void {
    this.workflow_role = this.userData.Roles.find(
      (p) => p.IsWorkflowRole == true
    ).Id;
    this.workflow_rolename = this.userData.Roles.find(
      (p) => p.IsWorkflowRole == true
    ).Code;
    this.workflow_user = this.userData.User.UserName;

    this.loadActivities(this.currentPage, this.pageSize);
  }

  loadActivities(page: number = 1, pageSize: number = 10) {
    this.isLoading = true;
    this.service
      .getGroupActivity(this.workflow_rolename, page, pageSize)
      .subscribe(
        async (result: any) => {
          this.activities = await this.matchApplications(result);
        },
        (error) => {
          this.toater.error(
            "Failed to load user activity. Please try again",
            "Activity"
          );
          this.isLoading = false;
        }
      );
  }

  matchApplications(results): Observable<any> {
    var listactivities: any = [];
    results.data.forEach((item) => {
        var obj = {
          id: item.id,
          applicationId: item.applicationId,
          applicationType: item.applicationType,
          activityStatus: item.activityStatus,
          datereceived: item.datereceived,
          userassigned: item.userAssigned,
          roleassignedid: item.roleAssignedId,
          applicant: item.applicant,
          group: item.wfGroup
        };

        listactivities.push(obj);

    });

    this.isLoading = false;
    return listactivities;
  }

  onProcess(item) {
    this.dialog.confirmThis(`This action will assign the activity to you. Are you sure you want to continue?`,
    () => {
      console.log("Yes")
      this.isLoading = true;
      this.service.assignActivityToUser(this.workflow_user, item.id)
      .subscribe(
        async (result: any) => {
          this.toater.success(`Activity successfully assigned to ${this.workflow_user}`,"Activity");
          this.isLoading = false;
          this.router.navigate([`/workflow/myinbox`]);
        },
        (error) => {
          this.toater.error(
            "Failed to assign user to activity. Please try again",
            "Activity"
          );
          this.isLoading = false;
        }
      );
    },
    () => {
      console.log("No")
      return;
    });
  }

  backToList(){
    this.router.navigate([`/workflow/myinbox`]);
  }

  //#region Paging
  onNextOrPrevious(page: number = 1) {
    this.loadActivities(page, this.pageSize);
    this.currentPage = page;
    return page;
  }

  onChange = () => {
    this.loadActivities((this.utility.page = 1), this.pageSize);
  };

  //#endregion

  //#region Sorting
  onSort(rank: number) {
    this.direction = !this.direction;
    this.rankCtrl = rank;
    this.onExcuteSort(rank);
    this.loadActivities(this.utility.page, this.pageSize);
  }

  onResetFlags() {
    this.flags = {
      flagAN: 1,
      flagAT: 1,
      flagS: 1,
      flagDA: 1,
    };
  }

  onExcuteSort(rank: number) {
    this.onResetFlags();
    let sort = this.direction ? 3 : 2;
    this.criteria = null;
    switch (rank) {
      case this.ranks.flagAN: {
        this.criteria = this.sortLabels.flagAN;
        this.flags.flagAN = sort;
        break;
      }
      case this.ranks.flagAT: {
        this.criteria = this.sortLabels.flagAT;
        this.flags.flagAT = sort;
        break;
      }
      case this.ranks.flagS: {
        this.criteria = this.sortLabels.flagS;
        this.flags.flagS = sort;
        break;
      }
      case this.ranks.flagDA: {
        this.criteria = this.sortLabels.flagDA;
        this.flags.flagDA = sort;
        break;
      }
      default: {
        this.criteria = this.sortLabels.flagDA;
        this.flags.flagDA = sort;
        break;
      }
    }
  }
  //#endregion


  getListData() {
    this.isLoading = true;
   /*  this._service
      .getAdminAnnualCompList(this.currentPage, this.pageSize)
      .subscribe(
        (result: any) => {
          this.annualComplianceListData = result?.m_Item1;
          this.count = result?.m_Item2;
          this.utility.onSort(1);
          this.isLoading = false;
          this.isEmpty = false;
        },
        (error) => {
          this.isEmpty = true;
          this.isLoading = false;
        }
      ); */
  }

  resetPages() {
    this.pageSize = 10;
    this.currentPage = 1;
  }

  applyFilter(filters) {

    console.log(filters)

    this.resetPages();

    if (!filters) {
      this.keyword = {};
      this.loadActivities();
    } else {

    this.selectedItems = filters?.Statuses;
    (this.keyword.WFAppType = filters?.WFAppType? filters?.WFAppType : ""),
    (this.keyword.CarrierName = filters?.CarrierName? filters.CarrierName : ""),
    (this.keyword.Statuses = this.selectedItems ? this.selectedItems.map((status) => {  return status.id; }) : []);
    
    if (filters) {
        this.loadFilteredActivities();
        console.log(this.keyword)
      } else {
        this.loadActivities();
      }
    }
  }

  loadFilteredActivities(page: number = 1, pageSize: number = 10) {
    this.isLoading = true;
    this.service
      .getUserActivityFiltered(this.keyword, this.workflow_role, this.workflow_user, page, pageSize)
      .subscribe(
        async (result: any) => {
          this.activities = await this.matchApplications(result);
        },
        (error) => {
          this.toater.error(
            "Failed to load user activity. Please try again",
            "Activity"
          );
          this.isLoading = false;
        }
      );
  }

   
}

